import React from "react";
import { getArrayObject } from "./lodash";
import { ShowToast, toastType } from "./toast-service";

/**
 * validation check for date input
 * @param {*} dataList 
 * @param {*} validateArr 
 * @returns 
 */
function validateInput(dataList = [], validateArr = []) {
  let incorrectValues = "";
  let emptyValues = "";
  for (const keys in dataList) {
    const obj = getArrayObject(validateArr, { valueKey: keys });
    if (obj) {
      emptyValues +=
        (obj.type === "number" ? isNaN(dataList[keys]) : !dataList[keys]) &&
        obj.isRequired
          ? obj.fieldsName + ", "
          : "";
      incorrectValues += validateDataByType(dataList[keys], obj);
    }
  }

  if (emptyValues) {
    ShowToast(
      <>
        <b>{"Missing Data: "} </b>
        <br /> {emptyValues.trim().slice(0, -1)}{" "}
      </>,
      toastType.ERROR,
      5000,
      200
    );
    return false;
  } else if (incorrectValues) {
    ShowToast(
      <>
        <b>{"Invalid Data: "} </b>
        <br /> {incorrectValues.trim().slice(0, -1)}{" "}
      </>,
      toastType.ERROR,
      5000,
      200
    );
    return false;
  }
  return true;
}

/**
 * Regex validation for different type of data
 * @param {*} data 
 * @param {*} param1 
 * @returns 
 */
function validateDataByType(
  data = "",
  { type = "text", isRequired = false, fieldsName = "" }
) {
  if (isRequired && (type === "number" ? isNaN(data) : !data)) {
    return fieldsName + ", ";
  }

  switch (type) {
    case "text":
      return "";

    case "email": {
      let isValidEmail = true;
      const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      isValidEmail = emailRegex.test((data || "").toString().toLowerCase());
      return isValidEmail || data == "" || data == null
        ? ""
        : fieldsName + ", ";
    }
    case "phone": {
      if (data == "") return "";
      let isValidPhone = true;
      const phoneRegex = /(?=(?:\D*\d){10,15}\D*$)/;
      isValidPhone = phoneRegex.test((data || "").toString().toLowerCase());
      return !isValidPhone ? fieldsName + ", " : "";
    }
    case "number": {
      let isValid3 = true;
      const numberRegex = new RegExp("^[0-9]*\\.?[0-9]*$");
      isValid3 = data && data.length > 0 ? numberRegex.test(data) : false;
      return !isValid3 ? fieldsName + ", " : "";
    }
    case "decimal":
      return "";

    case "array":
      return (data || []).length <= 0 ? fieldsName + ", " : "";

    case "date": {
      if (data == "Invalid date") {
        return fieldsName + ", ";
      } else {
        return isValidDate(data) || data == "" || data == null
          ? ""
          : fieldsName + ", ";
      }
    }
    case "datetime": {
      if (data == "Invalid date") {
        return fieldsName + ", ";
      } else {
        return isValidDateTime(data) || data == "" || data == null
          ? ""
          : fieldsName + ", ";
      }
    }
    case "alphaNumeric": {
      let isValid9 = true;
      const alphaNumericRegex = /^[a-zA-Z0-9\s]+$/;
      isValid9 = data && data.length > 0 ? alphaNumericRegex.test(data) : true;
      return !isValid9
        ? "Only letters and numbers are allowed on " + fieldsName + ", "
        : "";
    }
    default:
      return "";
  }
}

/**
 * date time validation
 * @param {*} dateString 
 * @returns 
 */
function isValidDateTime(dateString) {
	if (dateString !== null) {
		return true;
	} else {
		return false;
	}
}

/**
 * date validation with regex
 * @param {*} dateString 
 * @returns 
 */
function isValidDate(dateString) {
	/**
	 * First check for the pattern
	 */
	if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) return false;

	/**
	 * Parse the date parts to integers
	 */
	const parts = dateString.split("/");
	const day = parseInt(parts[1], 10);
	const month = parseInt(parts[0], 10);
	const year = parseInt(parts[2], 10);

	/**
	 * Check the ranges of month and year
	 */
	if (year < 1000 || year > 3000 || month == 0 || month > 12) return false;

  const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

	/**
	 * Adjust for leap years
	 */
	if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
		monthLength[1] = 29;

	/**
	 * Check the range of the day
	 */
	return day > 0 && day <= monthLength[month - 1];
}

export { validateInput, validateDataByType, isValidDate, isValidDateTime };
